import {GetEvBatteryManufacturerResponse} from '@di-shared/api/di/__generated';

export const BatteryManufacturerName = {
  [GetEvBatteryManufacturerResponse.batteryManufacturer.SK_ON]: 'SK온',
  [GetEvBatteryManufacturerResponse.batteryManufacturer.CATL]: 'CATL',
  [GetEvBatteryManufacturerResponse.batteryManufacturer.LG_ENERGY_SOLUTION]: 'LG에너지솔루션',
};

export enum EvBatteryPerformanceStatus {
  GOOD,
  NORMAL,
  ERROR,
}
